export default __webpack_public_path__ + "static/Curve-color-11-ebc5ce1a19ec26620b24b4af6f750aa7.svg";